import type { BoardDefinition } from '@skyrover/shared/types';

let activeBoard: BoardDefinition | null = null;

export function setActiveBoard(board: BoardDefinition | null): void {
  activeBoard = board;
}

export function getActiveBoard(): BoardDefinition | null {
  return activeBoard;
}

export function getDigitalPinOptions(): [string, string][] {
  if (!activeBoard) {
    return [['13', '13']];
  }
  return activeBoard.pins.digital.map((pin) => [String(pin), String(pin)]);
}

export function getPwmPinOptions(): [string, string][] {
  if (!activeBoard) {
    return [['9', '9']];
  }
  const pwm = activeBoard.pins.pwm ?? activeBoard.pins.digital;
  return pwm.map((pin) => [String(pin), String(pin)]);
}

export function getAnalogPinOptions(): [string, string][] {
  if (!activeBoard) {
    return [['A0', 'A0']];
  }
  const analog = activeBoard.pins.analog ?? [];
  if (analog.length === 0) {
    return activeBoard.pins.digital.slice(0, 6).map((pin) => [String(pin), String(pin)]);
  }
  return analog.map((pin) => [pin, pin]);
}

export function getPinModeOptions(): [string, string][] {
  return [
    ['INPUT', 'INPUT'],
    ['OUTPUT', 'OUTPUT'],
    ['INPUT_PULLUP', 'INPUT_PULLUP'],
  ];
}

export function getLogicLevelOptions(): [string, string][] {
  return [
    ['HIGH', 'HIGH'],
    ['LOW', 'LOW'],
  ];
}

export function getDefaultSerialBaud(): number {
  return activeBoard?.serial.defaultBaud ?? 9600;
}

export function getSerialBaudOptions(): [string, string][] {
  const bauds = activeBoard?.serial.supportedBauds ?? [9600, 115200];
  return bauds.map((baud) => [String(baud), String(baud)]);
}

export function analogPinToCode(pin: string): string {
  if (pin.startsWith('A')) {
    const index = parseInt(pin.slice(1), 10);
    return `A${index}`;
  }
  return pin;
}
